import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export const RESOURCES: ReadonlyArray<
	Readonly<{
		id: string;
		href: string;
		label: TranslationKey;
		note: TranslationKey;
	}>
> = [
	{
		id: 'blog',
		href: 'https://www.change.org/l/us',
		label: translationKey('corgi.press_page.resources.items.blog.label'),
		note: translationKey('corgi.press_page.resources.items.blog.note'),
	},
	{
		id: 'faq',
		href: 'https://help.change.org/s/?language=en_US',
		label: translationKey('corgi.press_page.resources.items.faq.label'),
		note: translationKey('corgi.press_page.resources.items.faq.note'),
	},
	{
		id: 'business_model',
		href: 'https://www.change.org/about/business-model',
		label: translationKey('corgi.press_page.resources.items.business_model.label'),
		note: translationKey('corgi.press_page.resources.items.business_model.note'),
	},
	{
		id: 'promoted_petitions',
		href: 'https://help.change.org/en_US/what-does-it-mean-to-promote-a-petition',
		label: translationKey('corgi.press_page.resources.items.promoted_petitions.label'),
		note: translationKey('corgi.press_page.resources.items.promoted_petitions.note'),
	},
];
